
<template>
  <div id="app">
    <div class="contentgrid" :style="'height:'+vh">
      <Carousel
        ref="contentgrid"
        :dataArray="datatext"
        :loading="true"
        :shouldPause="true"
        @change="change"
      >
        <div slot="slidetitle" slot-scope="{ htmlText }">
          <div class="meta">物种</div>
          <h2 id="slide-title" ref="slidetitle">{{ htmlText.TitleName }}</h2>
        </div>
        <div slot="slidestatus" slot-scope="{ htmlText }">
          <div class="meta">保护现状</div>
          <div id="slide-status" ref="slidestatus">
            {{ htmlText.StatusName }}
          </div>
        </div>
      </Carousel>  
      <!-- <Contentgrid
        ref="contentgrid"
        :dataArray="datatext"
        :loading="true"
        :shouldPause="true"
        @change="change"
      >
        <div slot="slidetitle" slot-scope="{ htmlText }">
          <div class="meta">物种</div>
          <h2 id="slide-title" ref="slidetitle">{{ htmlText.TitleName }}</h2>
        </div>
        <div slot="slidestatus" slot-scope="{ htmlText }">
          <div class="meta">保护现状</div>
          <div id="slide-status" ref="slidestatus">
            {{ htmlText.StatusName }}
          </div>
        </div>
      </Contentgrid>  -->
    </div>
  </div>
</template>

<script>
import { Contentgrid,Carousel } from "contentgrid";

export default {
  name: "App",
  components: {
    Contentgrid,
    Carousel
  },
  data() {
    return {
      vh: 0,
      datatext: [
        {
          id: 0,
          TitleName: "远东豹",
          StatusName: "极度濒危",
          image: require("./assets/leopard2.jpg"),
        },
        {
          id: 1,
          TitleName: "亚洲狮",
          StatusName: "濒危",
          image: require("./assets/lion2.jpg"),
        },
        {
          id: 2,
          TitleName: "西伯利亚虎",
          StatusName: "濒危",
          image: require("./assets/tiger2.jpg"),
        },
        {
          id: 3,
          TitleName: "棕熊",
          StatusName: "无危",
          image: require("./assets/bear2.jpg"),
        },
      ],
    };
  },
  methods: {
    change(index) {
      console.log(index);
    },
  },
  created() {
     this.vh = window.innerHeight+'px'
  },
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
}

.contentgrid {
  width: 100%;
  position: relative;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/App.vue